import { render, staticRenderFns } from "./NovelList.vue?vue&type=template&id=42592413&scoped=true"
import script from "./NovelList.vue?vue&type=script&lang=ts"
export * from "./NovelList.vue?vue&type=script&lang=ts"
import style0 from "./NovelList.vue?vue&type=style&index=0&id=42592413&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42592413",
  null
  
)

export default component.exports